/**
 * SectionLabel — small uppercase section heading with a divider line.
 * Single responsibility: visual section separator within a tab.
 */

import React from 'react';

export interface SectionLabelProps {
  label: string;
  isDark: boolean;
}

/**
 * SectionLabel component — uppercase label with a horizontal rule.
 */
export const SectionLabel: React.FC<SectionLabelProps> = ({ label, isDark }) => {
  const textSecondary = isDark ? '#94a3b8' : '#9ca3af';
  const dividerColor = isDark ? 'rgba(51,65,85,0.4)' : '#e2e8f0';

  const wrapperStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginTop: 12,
    marginBottom: 6,
  };

  const textStyle: React.CSSProperties = {
    fontSize: 10,
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    color: textSecondary,
    whiteSpace: 'nowrap',
    flexShrink: 0,
  };

  const lineStyle: React.CSSProperties = {
    flex: 1,
    height: 1,
    background: dividerColor,
  };

  return (
    <div style={wrapperStyle}>
      <span style={textStyle}>{label}</span>
      <div style={lineStyle} />
    </div>
  );
};

SectionLabel.displayName = 'SectionLabel';
